export const Loader = () => {
  return (
    <div className='flex flex-grow items-center justify-center'>
      <div className='loading loading-infinity loading-lg text-primary'></div>
    </div>
  );
};
